import { render } from "./cdrBatchServer.vue?vue&type=template&id=7bcf20aa&scoped=true"
import script from "./cdrBatchServer.vue?vue&type=script&lang=js"
export * from "./cdrBatchServer.vue?vue&type=script&lang=js"

import "./cdrBatchServer.vue?vue&type=style&index=0&id=7bcf20aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7bcf20aa"

export default script